import React, { useState, Suspense, lazy } from 'react';
import {Button, Grow } from '@material-ui/core';
import {ReactComponent as MessageBubbles} from '../assets/message-bubbles.svg';
import {makeStyles} from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import ContactWidgetStyles from '../styles/contactWidgetStyles';
import Icons from '../lib/icons';
import WatchLaterIcon from '@material-ui/icons/WatchLater';
import GradeIcon from '@material-ui/icons/Grade';
import { __ } from '../lib/localization';

const PrimaryCta = (props) => {
    const [ isTransitionHighlightButton, setisTransitionHighlightButton ] = useState(false);
    setTimeout(() => {
        setisTransitionHighlightButton(true);
    }, 500);

    let HighlightIcon = <></>;
    let HighlightText = <></>;
    if (props.isShowHighlight && props.highlight.type === 'response_time') {
        HighlightIcon = <WatchLaterIcon className={props.classes.highlight_icon} />;
        HighlightText = `${__('highlight_response')}: < ${props.highlight?.metadata?.time ?? '5'} ${props.highlight?.metadata?.unit}`;
    }
    else if (props.isShowHighlight && props.highlight.type === 'reputation') {
        HighlightIcon = <GradeIcon className={props.classes.highlight_icon} />;
        HighlightText = `${props.highlight?.metadata?.rating ? Number(props.highlight?.metadata?.rating).toFixed(1) : 'n/a'} Stars - ${ (props.highlight?.metadata?.count ?? 0).toLocaleString('en-US')} ${__('highlight_reviews')}` ;
    }
    else if (props.isShowHighlight && props.highlight.type === 'custom') {
        HighlightText = props.highlight?.metadata?.text;
    }
    return (
        <div>
            <Button
                classes={
                    {
                        root: `${props.classes.button}`,
                        label: `${props.classes.button__label}`,
                        text: props.classes.text
                    }
                }
                className={props.classes.primaryCtaButton}
                onClick={props.onPrimaryCtaClick}
                centerRipple="true"
                style={{opacity: props.showMainButton ? '1' : '0', visibility: props.showMainButton ? 'visible' : 'hidden'}}
                aria-label={props.primaryCta?.text ?? __('leadbox_primary_cta_text')}
            >
                {!props.isIconOnly &&
                    <span className={props.classes.spanText}>{props.primaryCta?.text ?? __('leadbox_primary_cta_text').toUpperCase()}</span>
                }
                <span className={props.classes.buttonIcon} style={{backgroundColor: props.rootAccentColor}}>
                    <Suspense fallback={<div></div>}>
                        {
                            props.primaryCta?.icon && Icons[props.primaryCta?.icon]
                                ? React.createElement(Icons[props.primaryCta?.icon], {style: {height: '28px', width: '28px', margin: '0 auto', color: '#fff'}, 'aria-hidden': true, 'focusable': false})
                                : <MessageBubbles style={{width: '28px', margin: '0 auto'}} aria-hidden="true" focusable="false" />
                        }
                    </Suspense>
                </span>
            </Button>


            {props.showMainButton && props.isShowHighlight ? (
                <div className={props.classes.highlight_button_container}>
                    <Grow
                        direction="up"
                        timeout={{enter: 500}}
                        in={isTransitionHighlightButton}
                        onEntered={() => { }}
                    >
                        <Button
                            classes={
                                {
                                    root: `${props.classes.button}`,
                                    label: `${props.classes.button__label}`,
                                    text: props.classes.text
                                }
                            }
                            className={['is-highlight-button']}
                            onClick={props.onPrimaryCtaClick}
                            aria-label={props.primaryCta?.highlight?.metadata?.text}
                            style={{position: 'static'}}
                        >
                            <span style={{display: 'flex', alignItems: 'center', alignContent: 'center', width: '100%', justifyContent: 'center', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                <span style={{display: 'inline-flex'}}>
                                    {HighlightIcon}
                                </span>
                                <span>{HighlightText}</span>
                            </span>
                        </Button>
                    </Grow>
                </div>
            ) : (<></>)}

            <Button
                className={props.classes.hide_desktop}
                onClick={props.handleCloseLeadbox}
                classes={{
                    root: props.classes.button__close,
                    label: props.classes.buttonClose__text,
                    text: props.classes.buttonClose__text,
                }}
                style={{opacity: props.showMainButton ? '0' : '1', backgroundColor: props.rootAccentColor, visibility: props.showMainButton ? 'hidden' : 'visible'}}
                aria-label="Close"
            >
                <CloseIcon style={{fontSize: 35}}/>
            </Button>
        </div>
    )
}

export default PrimaryCta;
